export function ApiError({ onRetry, testid = "api-error" }) {
  return (
    <div role="alert" data-testid={testid} className="luma-card flex flex-wrap items-center justify-between gap-3 p-5 text-[15px]">
      <span>Non riusciamo a caricare i contenuti in questo momento. Controlla la connessione e riprova.</span>
      <button type="button" onClick={onRetry} data-testid={`${testid}-retry`} className="luma-btn-ghost !min-h-[44px]">Riprova</button>
    </div>
  );
}
